import { useMemo } from 'react';
import isEmpty from 'lodash/isEmpty';
import isDefined from '../../utils/isDefined';
import { ISelectOption, TSelectProps } from '../interfaces';

const useSelectValue = (selectProps: Pick<TSelectProps, 'value' | 'options' | 'isGrouped' | 'isMulti'>) => {
    const {
    isGrouped,
    isMulti,
  } = selectProps;
  const value = useMemo(() => {
    if (isMulti || isGrouped) {
      const inputValue = selectProps.value as ISelectOption[];

      if (inputValue.length && typeof inputValue[0] === 'object') {
        return inputValue.map((item) => (
          { ...item, value: item.value, label: item.label }
        ));
      }

      return inputValue;
    }

    const inputValue = selectProps.value as ISelectOption;

    if (!isDefined(inputValue)) {
      return null;
    }

    const options = selectProps.options as ISelectOption[];

    const filterOptions = options?.filter((option) => {
      if (inputValue && typeof inputValue === 'object') {
        return option.value === inputValue.value;
      }

      return option.value === inputValue;
    });

    if (isEmpty(filterOptions) && !isEmpty(inputValue)) {
      return inputValue;
    }

    return filterOptions;
  }, [selectProps.value, selectProps.options, isMulti, isGrouped]);

  return { value };
};

export default useSelectValue;
